import { GlobalData } from "../../Common/GlobalData";
import { TemplateHelpers } from "../../Common/KendoHelpers";

export class RsLineBlueDotTrendTemplates {
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(RsLineBlueDotTrendTemplates.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_RS_LINE_BLUE_DOT_TREND_TEMPLATES,
                }
            },
            height: 915,
            groupable: false,
            pageable: false,
            sortable: true,
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'companyName',
                title: 'Company Name',
                width: '30%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'numBlueDots',
                title: 'Number<br>BlueDots',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'dateOfLastBlueDot',
                title: 'Last<br>Blue Dot',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('dateOfLastBlueDot')),
            }, {
                field: 'dailyWeekly',
                title: 'Daily<br>Weekly',
                width: '8%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'month1',
                title: 'Trend<br>Month1',
                width: '8%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month1 ? "Yes" : "" #',
            }, {
                field: 'month1To4',
                title: 'Trend<br>Month1-4',
                width: '8%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month1To4 ? "Yes" : "" #',
            }, {
                field: 'month5',
                title: 'Trend<br>Month5',
                width: '8%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month5 ? "Yes" : "" #',
            }, {
                field: 'month5Wide',
                title: 'Trend<br>Month5Wide',
                width: '8%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month5Wide ? "Yes" : "" #',
            }]
        });
    }
}
